import { render, staticRenderFns } from "./ReportMealsTabRestaurants.vue?vue&type=template&id=6537307f"
import script from "./ReportMealsTabRestaurants.vue?vue&type=script&lang=js"
export * from "./ReportMealsTabRestaurants.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports